import constant from '../../mixins/const';
import axios from "axios";
// import axios from "axios";
const BigNumber = require('bignumber.js');
const CryptoJS = require('crypto-js');
const bitcore = require('bitcore-lib');
const Mnemonic = require('bitcore-mnemonic');
// const ethers = require('ethers');
const hdkey = require('ethereumjs-wallet/hdkey');
const bip39 = require("bip39");
const rippleKP = require('ripple-keypairs');
const {Wallet, WalletFactory, XrplNetwork} = require('xpring-common-js');

const settingStoreName = 'settings';
const currencyAccountStoreName = 'currencyAccounts';

const bitcoinHost = constant.blockchainHost.Bitcoin;
const ethereumHost = constant.blockchainHost.Ethereum;

const blockStreamApiPath = (constant.blockchainEnv == 'test')?'testnet/':'';


/**
 * vwIdb
 * accounts->import済みのアカウント情報を収納
 *
 * settings->optKeyによって収納する情報を分けている
 * ┗currentAccount=>loginId: string(現在選択中のアカウント)
 */
import {generateKey} from '@/mixins/interface';
import {currencyData} from '@/mixins/interface';
import {settings} from '@/mixins/interface';

const state = {
    enteredMnemonic: '',
    preImport: {}
}

const getters = {
    // countWithSuffix(state: any) {
    //     return `${state.counter} 回`
    // },
    getEnteredMnemonic(state: any) {
        return state.enteredMnemonic;
    },
    getPreImport(state: any) {
        return state.preImport;
    }
}

const actions = {
    // incActionCounter(store: any, payload: any){
    //     // Mutationsへ
    //     store.commit('incrementMutateCounter', payload)
    // },
    generateAccounts(store: any, data: {pin: string, mnemonic: string|null, lang: string}) {
        return new Promise((resolve, reject) => {
            console.log('generate start data.mnemonic', data.mnemonic);
            let mnemonic = null;
            let validation = true;
            let restored = false;
            if (data.mnemonic == undefined || data.mnemonic == null) {
                mnemonic = new Mnemonic(Mnemonic.Words.JAPANESE);
            } else {
                restored = true;
                mnemonic = new Mnemonic(data.mnemonic);

                // var valid = Mnemonic.isValid(data.mnemonic);
                // console.log('valid', valid);
                validation = Mnemonic.isValid(data.mnemonic, Mnemonic.Words.JAPANESE);
                console.log('validation', validation);
            }
            console.log("mnemonic code: " + mnemonic.toString());
            if (validation) {
                const keyData: generateKey = {
                    mnemonic: mnemonic,
                    pin: data.pin,
                    order: 0,
                    display: true,
                    restored: restored,
                }
                const saveArgument = {
                    pin: data.pin,
                    mnemonic: mnemonic.toString().replace(/　/g, ' ')
                }

                store.dispatch('generateBitcoinAccount', keyData)
                .then(function() {
                    return store.dispatch('generateEthereumAccount', keyData);
                })
                .then(function() {
                    return store.dispatch('generateRippleAccount', keyData);
                })
                .then(function() {
                    return store.dispatch('setDefaultTokenAccounts', keyData);
                })
                .then(function() {
                    return store.dispatch('saveMnemonic', saveArgument);
                })
                .then(function() {
                    /**
                     * timezoneを初期化
                     */
                    const saveData: settings = {
                        optKey: 'timezone',
                        optValue: constant.defaultTimezone
                    }
                    return store.dispatch('idbPut', {stateName: null, storeName: settingStoreName, data: saveData}, { root: true });
                })
                .then(function() {
                    /**
                     * アカウントの作成日時(UTC)を保存する
                     */
                    const today = constant.utcToday();
                    const createdData: settings = {
                        optKey: 'created',
                        optValue: today
                    }
                    return store.dispatch('idbPut', {stateName: 'created', storeName: settingStoreName, data: createdData}, { root: true })
                })
                .then(function() {
                    /**
                     * デフォルトの国を保存する
                     */
                    // TODO: chの場合は中国など、言語がほぼ一か国でしか使われていない場合は日本語同様の対応を行う
                    let countryCode = '';
                    if (data.lang == 'ja') {
                        countryCode = 'JPN';
                    }
                    const countryData: settings = {
                        optKey: 'country',
                        optValue: countryCode
                    }
                    return store.dispatch('idbPut', {stateName: null, storeName: settingStoreName, data: countryData}, { root: true })
                })
                .then(async () => {
                    // バージョンの保管
                    const apiUrl: string = constant.apiHost + '/api/setting/request';
                    let params = new URLSearchParams();
                    params.append('setting_key', 'version');
                    axios.post(apiUrl + `?t=${new Date().getTime()}`, params)
                    .then(async (response: any) => {
                        console.log('ver',response);
                        const version: any = response.data.data.setting_value;

                        const verData = {
                            optKey: 'currentVersion',
                            optValue: version
                        }
                        await store.dispatch('idbPut', {stateName: null, storeName: 'settings', data: verData}, {root: true});
                    })
                    .catch(async () => {
                        const verData = {
                            optKey: 'currentVersion',
                            optValue: '0.1.0'
                        }
                        await store.dispatch('idbPut', {stateName: null, storeName: 'settings', data: verData}, {root: true});
                    })
                    .finally(() => {
                        return true;
                    });
                })
                .then(function() {
                    resolve(true);
                })
                .catch(function(e: string) {
                    reject(e);
                });
            } else {
                reject('mnemonic code validation error');
            }
        });
    },

    saveMnemonic(store: any, data: {pin: string, mnemonic: string}) {
        return new Promise((resolve) => {
            const saveData: settings = {
                optKey: 'generateMnemonic',
                optValue: CryptoJS.AES.encrypt(data.mnemonic, data.pin).toString()
            }
            store.dispatch('idbPut', {stateName: null, storeName: settingStoreName, data: saveData}, { root: true })
            .then(function() {
                resolve(true);
            });
        });
    },
    setDefaultTokenAccounts(store: any) {
        return new Promise(async (resolve) => {
            let defaultEtherAccount = await store.dispatch('idbSelect', {stateName: null, storeName: 'currencyAccounts', keyValue: 'Ether'}, {root: true});
            const allData = await store.dispatch('getAllCurrencyAccounts');
            const order = allData.length+1;
            const defaultTokenList = constant.defaultTokenList;
            for(let i = 0; i < defaultTokenList.length; i++) {
                const name = defaultTokenList[i].name;
                const contractAddress = defaultTokenList[i].address;
                const contractData = await store.dispatch('walletModule/getERC20InfoByContractAddress', contractAddress, {root: true});
                const currencyData: currencyData = {
                    name: contractData.name,
                    symbol: contractData.symbol,
                    privateKey: defaultEtherAccount.privateKey,
                    publicKey: defaultEtherAccount.publicKey,
                    address: defaultEtherAccount.address,
                    subAddress: '',
                    changeAddress: '',
                    privIdx: 0,
                    changePrivIdx: 0,
                    accountNumber: null,
                    type: 2, // 1.exist Original, 2.exist Token, 3.imported Original, 4.imported Token,
                    platform: 'ERC20',  // Bitcoin,Ether,Ripple,ERC20
                    iconName: name,
                    contractAddress: contractAddress,
                    tokenDecimals: contractData.decimals,
                    amount: 0,
                    order: order + i,
                    display: true,
                    initialized: false
                }
                await store.dispatch('idbAdd', {stateName: null, storeName: 'currencyAccounts', data: currencyData}, {root: true});
            }
            resolve(0);
        });
    },
    importAccount(store: any, payload: {pin: number, currencyData: currencyData, importProcess: number}) {
        return new Promise(async (resolve) => {
            const importProcess = payload.importProcess;
            switch (importProcess) {
                case 1:
                    // 既定の通貨をウォレット内で生成
                    if (payload.currencyData.platform == 'Bitcoin') {
                        await store.dispatch('addBitcoinAccount', {pin: payload.pin, currencyData: payload.currencyData});
                    } else if (payload.currencyData.platform == 'Ether') {
                        await store.dispatch('addEthereumAccount', {pin: payload.pin, currencyData: payload.currencyData});
                    } else if (payload.currencyData.platform == 'Ripple') {
                        await store.dispatch('addRippleAccount', {pin: payload.pin, currencyData: payload.currencyData});
                    }
                    break;
                case 2:
                    // 既定の通貨を外部から読み込む
                    await store.dispatch('importNewCurrencyAccount', {pin: payload.pin, currencyData: payload.currencyData});
                    break;
                case 3:
                    // トークンをウォレット内のアドレスを使用して読み込む
                    await store.dispatch('idbAdd', {stateName: null, storeName: 'currencyAccounts', data: payload.currencyData}, { root: true });
                    break;
                case 4:
                    // トークンを外部から読み込む
                    await store.dispatch('importNewCurrencyAccount', {pin: payload.pin, currencyData: payload.currencyData});
                    break;
            }
            resolve(true);
        });
    },

    generateBitcoinAccount(store: any, keyData: generateKey) {
        return new Promise(async (resolve, reject) => {
            const network = constant.blockchainEnvName.Bitcoin;

            const code = keyData.mnemonic;
            console.log('network', network);

            // ニーモニック -> 親秘密鍵
            // const masterPriv = code.toHDPrivateKey(keyData.pin, network); // ニーモニックと暗証番号から生成
            const masterPriv = code.toHDPrivateKey('vw', network); // ニーモニックから生成
            console.log("masterPriv: " + masterPriv.toString());
            console.log("masterPriv(org):", masterPriv);
            // settingsに親秘密鍵を保存
            const masterData = {
                optKey: 'bhdk',
                optValue: CryptoJS.AES.encrypt(masterPriv.toString(), keyData.pin).toString()
            }
            const restored = keyData.restored;
            const platform = 'Bitcoin';

            // 受け取りアドレス作成
            const receiveAccount = await store.dispatch('generateCryptoCurrencyAccount', {
                accountNumber: 0,
                masterPriv: masterPriv,
                platform: platform,
                restored: restored,
                change: false
            });
            // おつりアドレス作成
            const changeAccount = await store.dispatch('generateCryptoCurrencyAccount', {
                accountNumber: 0,
                masterPriv: masterPriv,
                platform: platform,
                restored: restored,
                change: true
            });

            const data: currencyData = {
                name: 'Bitcoin',
                symbol: 'BTC',
                privateKey: '', // マルチシグ＆非固定アドレスによりアドレスを複数保持することになり意味がないため保管しない
                publicKey: '',
                address: receiveAccount.address,// あくまでも現在の受け取りアドレス
                subAddress: '',
                changeAddress: changeAccount.address,// あくまでも現在のおつりアドレス
                privIdx: receiveAccount.privIdx,
                changePrivIdx: changeAccount.privIdx,
                accountNumber: 0,
                type: 1,
                platform: 'Bitcoin',
                iconName: 'Bitcoin',
                contractAddress: '',
                tokenDecimals: 8,
                amount: 0,
                order: 1,
                display: keyData.display,
                initialized: false
            };
            if (keyData.order != 0) {
                data.order = keyData.order;
            }

            store.dispatch('idbAdd', {stateName: null, storeName: currencyAccountStoreName, data: data}, { root: true })
            .then(function() {
                // 親鍵を保存
                return store.dispatch('idbPut', {stateName: null, storeName: settingStoreName, data: masterData}, { root: true });
            })
            .then(function() {
                resolve(true);
            })
            .catch(function(){
                reject('Bitcoin generate error');
            });

        });
    },

    addBitcoinAccount(store: any, payload: {pin: string, currencyData: currencyData}) {
        return new Promise(async (resolve) => {
            const masterPrivEncrypted = await store.dispatch('idbSelect', {stateName: null, storeName: settingStoreName, keyValue: 'bhdk'}, { root: true });
            const masterPrivStr = await store.dispatch('decryptWithPin', {pin: payload.pin, encrypted: masterPrivEncrypted.optValue});
            const masterPriv = bitcore.HDPrivateKey(masterPrivStr);
            let currencyData: currencyData = payload.currencyData;
            // 受け取りアドレス作成
            const receiveAccount = await store.dispatch('generateCryptoCurrencyAccount', {
                accountNumber: currencyData.accountNumber,
                masterPriv: masterPriv,
                platform: currencyData.platform,
                restored: true,
                change: false
            });
            // おつりアドレス作成
            const changeAccount = await store.dispatch('generateCryptoCurrencyAccount', {
                accountNumber: currencyData.accountNumber,
                masterPriv: masterPriv,
                platform: currencyData.platform,
                restored: true,
                change: true
            });

            currencyData.privateKey = '';
            currencyData.address = receiveAccount.address;
            currencyData.changeAddress = changeAccount.address;
            currencyData.privIdx = receiveAccount.privIdx;
            currencyData.changePrivIdx = changeAccount.privIdx;

            store.dispatch('idbAdd', {stateName: null, storeName: currencyAccountStoreName, data: currencyData}, { root: true });
            resolve(true);
        })
    },

    generateCryptoCurrencyAccount(store: any, data: any) {
        return new Promise(async (resolve,reject) => {
            let accountNumber = data.accountNumber;
            const masterPriv = data.masterPriv;
            const restored = data.restored;
            const platform = data.platform;
            const change = data.change;
            const GAP_LIMIT = 20; // 未使用アドレス連続検索最大数
            /**
             * お釣りの場合は最低1個出来ればOKで、受け取りアドレスは30個
             * 新規作成の場合: 受け取りアドレスは30個作成され、お釣りアドレスは1個作成
             * 復元の場合: 受け取りアドレスは未使用分を20個まで検索、その20個を含む30個作成され、
             *           お釣りアドレスも未使用分が20個検索されるため最低20個作成される->30個まで
             */
            let UNUSED_ADDRESS_KEEP_MIN_RESTORED = (change)?0:10; // 復元時未使用アドレスの最低余剰作成数
            let UNUSED_ADDRESS_KEEP_MIN_GENERATED = (change)?1:30; // 新規作成時未使用アドレスの最低余剰作成数
            let UNUSED_ADDRESS_KEEP_MAX = 30;
            let unusedAddressKept = 0;

            let searchEnd = false; // unusedAddressFound/savingEndの2つがtrueになった時にtrueになる
            let unusedAddressFound = false;// 未使用アドレス連続検索最大数に達したか（復元時）
            let savingEnd = false;// アドレスの最低作成数に達したか

            let privIdx = 0; // 秘密鍵のindex
            let gapIndex = 0;// 未使用アドレスの連続発見数
            let addressDataArray = [];
            let unusedIndex = 0;// 使用する未使用アドレスのprivIdx
            do {
                console.log(privIdx, '週目！')
                const addressCreatedData = await store.dispatch('createMultiSigAddress', {
                    masterPriv: masterPriv,
                    change: change,
                    accountNumber: accountNumber,
                    privIdx: privIdx,
                    platform: platform
                });
                if (addressCreatedData.address == '') {
                    reject('btc multisigwallet create error');
                }

                console.log('address', addressCreatedData.address);

                const addrData = {
                    accountNumber: accountNumber,
                    privIdx: privIdx, // このprivIdx*2+0,privIdx*2+1が使われる
                    change: (change)?1:0,
                    address: addressCreatedData.address,
                    amount: 0
                };

                // 未使用アドレスの選定が終わってない場合
                if (restored) {
                    // 復元の場合のみ下記実行
                    // どこまで利用されているか検索する
                    if (!unusedAddressFound) {
                        // 未使用かチェック
                        let unused: boolean = await store.dispatch('checkUnspentAddr', {
                            address: addressCreatedData.address,
                            platform: platform
                        });
                        if (unused) {
                            // 未使用のアドレス発見
                            gapIndex++;// 未使用アドレスの連続発見数
                            console.log(change, 'unused!!', addressCreatedData.address)
                            console.log('GAP_LIMIT', GAP_LIMIT)
                            console.log('gapIndex', gapIndex)
                        } else {
                            // 使用されているので調査続行
                            gapIndex = 0;// 未使用アドレスの連続発見数
                            const apiUrl = `https://blockstream.info/${blockStreamApiPath}api/address/${addressCreatedData.address}/utxo`;
                            const utxos = await axios.get(apiUrl);
                            let balances = 0
                            for(let i = 0; i < utxos.data.length; i++) {
                                if (utxos.data[i].confirmed) {
                                    balances = balances + parseInt(utxos.data[i].value);
                                }
                            }
                            addrData.amount = balances;
                            console.log(change, 'used!!', addressCreatedData.address)
                            console.log('GAP_LIMIT', GAP_LIMIT)
                            console.log('gapIndex', gapIndex)
                        }
                        if (GAP_LIMIT == gapIndex) {
                            /**
                             * 未使用のアドレス数をGAP_LIMIT個(20)連続でチェックしたら終了
                             * 20回目の検索だとしたら
                             * privIdx === 19
                             * unusedIndex = privIdx+1-GAP_LIMIT=0
                             * 21回目の検索だとしたら
                             * privIdx === 20
                             * unusedIndex = privIdx+1-GAP_LIMIT=1
                             */
                            unusedIndex = (privIdx + 1) - GAP_LIMIT;
                            console.log('unusedIndex', unusedIndex);
                            unusedAddressFound = true;
                        }
                    }


                } else {
                    // 新規の場合は作成のみ
                    unusedIndex = 0;
                    unusedAddressFound = true;
                    console.log('unusedIndex', unusedIndex);
                }

                addressDataArray.push(addrData);
                console.log('addressDataArray', addressDataArray);
                console.log('unused index!', unusedIndex);
                console.log('unused', addressDataArray[unusedIndex]);
                await store.dispatch('idbPut', {stateName: null, storeName: 'btcAddress', data: addrData}, {root: true});

                /**
                 * アドレス余剰作成数が余剰作成最低数に達せているかチェック
                 */
                if (restored) {
                    // 復元の場合
                    if (unusedAddressKept >= UNUSED_ADDRESS_KEEP_MIN_RESTORED) {
                        savingEnd = true;
                    }
                    if (unusedAddressFound) {
                        // 検索が終了している場合
                        unusedAddressKept++; //余剰作成数++
                    }
                } else if (!restored) {
                    // 新規作成の場合
                    if (unusedAddressKept >= UNUSED_ADDRESS_KEEP_MIN_GENERATED) {
                        savingEnd = true;
                    }
                    unusedAddressKept++; //余剰作成数++
                }

                if (savingEnd && unusedAddressFound) {
                    searchEnd = true;
                }

                if (privIdx >= UNUSED_ADDRESS_KEEP_MAX) {
                    searchEnd = true;
                }

                // nextPrivIdx
                privIdx++;
            } while(!searchEnd);// whileEnd

            const enableUnusedAddress = {
                address: addressDataArray[unusedIndex].address,
                privIdx: addressDataArray[unusedIndex].privIdx,
            };
            resolve(enableUnusedAddress);
        });
    },

    generateEthereumAccount(store: any, keyData: generateKey) {
        return new Promise((resolve, reject) => {
            const code = keyData.mnemonic;
            const mnemonic = code.toString().replace(/　/g, ' ');
            console.log('ether mnemonic:', mnemonic);
            // bip39.mnemonicToSeed(mnemonic, keyData.pin) // ニーモニックと暗証番号から生成
            bip39.mnemonicToSeed(mnemonic) // ニーモニックから生成
            .then(async function(seed: any) {
                console.log('eth seed:', seed);
                const hdwallet = hdkey.fromMasterSeed(seed);
                console.log('hdwallet', hdwallet);

                let wallet = hdwallet.derivePath("m/44'/60'/0'/0/0").getWallet();
                let address = wallet.getAddressString();
                let privateKey = wallet.getPrivateKeyString().slice(2); // 0x除去
                let publicKey = wallet.getPublicKeyString();
                console.log(address, privateKey);

                const masterData = {
                    optKey: 'ehdk',
                    optValue: CryptoJS.AES.encrypt(hdwallet.privateExtendedKey(), keyData.pin).toString()
                }

                const data: currencyData = {
                    name: 'Ether',
                    symbol: 'ETH',
                    privateKey: CryptoJS.AES.encrypt(privateKey, keyData.pin).toString(),
                    publicKey: publicKey,
                    address: address,
                    subAddress: '',
                    changeAddress: '',
                    privIdx: 0,
                    changePrivIdx: 0,
                    accountNumber: 0,
                    type: 1,
                    platform: 'Ether',
                    iconName: 'Ether',
                    contractAddress: '',
                    tokenDecimals: 18,
                    amount: 0,
                    order: 2,
                    display: keyData.display,
                    initialized: false
                };
                if (keyData.order != 0) {
                    data.order = keyData.order;
                }

                // works機能登録(失敗しても無視する)
                try {
                    // Works機能で利用するkeyを取得
                    const apiUrl: string = constant.apiHost + '/api/work/install-check';
                    let params = new URLSearchParams();
                    params.append('public_key', CryptoJS.SHA1(publicKey).toString());
                    params.append('eth_address', address);

                    const response = await axios.post(apiUrl, params);
                    const status = response.data.status;
                    if (status == 'success') {
                        const installerCode = response.data.data.code;
                        const worksData = {
                            optKey: 'installerCode',
                            optValue: installerCode
                        }
                        await store.dispatch('idbPut', {stateName: null, storeName: settingStoreName, data: worksData}, { root: true });
                    } else {
                        console.error('works register error');
                        throw new Error('works register error');
                    }
                } catch (e) {
                    console.error(e);
                }

                store.dispatch('idbAdd', {stateName: null, storeName: currencyAccountStoreName, data: data}, { root: true })
                .then(() => {
                    // 親鍵を保存
                    return store.dispatch('idbPut', {stateName: null, storeName: settingStoreName, data: masterData}, { root: true });
                })
                .then(() => {
                    resolve(true);
                })
                .catch(function(e: any){
                    reject('Ethereum generate error2');
                });
            })
            .catch(function(){
                reject('Ethereum generate error');
            });
        });
    },

    addEthereumAccount(store: any, payload: {pin: string, currencyData: currencyData}) {
        return new Promise(async (resolve) => {
            const masterPrivEncrypted = await store.dispatch('idbSelect', {stateName: null, storeName: settingStoreName, keyValue: 'ehdk'}, { root: true });
            const masterPriv = await store.dispatch('decryptWithPin', {pin: payload.pin, encrypted: masterPrivEncrypted.optValue});
            const hdwallet = hdkey.fromExtendedKey(masterPriv);
            let currencyData: currencyData = payload.currencyData;

            let wallet = hdwallet.derivePath("m/44'/60'/"+ currencyData.accountNumber +"'/0/0").getWallet();
            let address = wallet.getAddressString();
            let privateKey = wallet.getPrivateKeyString().slice(2); // 0x除去
            let publicKey = wallet.getPublicKeyString();
            console.log(address, privateKey);

            currencyData.privateKey = CryptoJS.AES.encrypt(privateKey, payload.pin).toString();
            currencyData.publicKey = publicKey;
            currencyData.address = address;

            store.dispatch('idbAdd', {stateName: null, storeName: currencyAccountStoreName, data: currencyData}, { root: true });
            resolve(true);
        })
    },

    generateRippleAccount(store: any, keyData: generateKey) {
        return new Promise((resolve, reject) => {
            console.log('start generate ripple');
            const code = keyData.mnemonic;
            // ニーモニック
            const mnemonic = code.toString().replace(/　/g, ' ');
            // const mnemonic = mnemonic128 + ' ' + mnemonic128;
            // console.log('mnemonic ripple:', mnemonic);

            // bip39.mnemonicToSeed(mnemonic, keyData.pin) // ニーモニックと暗証番号から生成
            bip39.mnemonicToSeed(mnemonic) // ニーモニックから生成
            .then(function(seed: any) {
                console.log('seed', seed);
                // const privateKey = rippleKP.generateSeed(seed);
                // console.log('privateKey', privateKey);
                // const keyPair = rippleKP.deriveKeypair(privateKey);
                // console.log('keyPair', keyPair);
                // const address = rippleKP.deriveAddress(keyPair.publicKey);
                // console.log('address', address);

                const test = (constant.blockchainEnv !== 'main');
                const wallet = Wallet.generateHDWalletFromSeed(seed, "m/44'/144'/0'/0/0", test);
                console.log(wallet.getAddress())
                console.log(wallet.privateKey);
                const classicAddress = rippleKP.deriveAddress(wallet.publicKey);


                const data: currencyData = {
                    name: 'Ripple',
                    symbol: 'XRP',
                    privateKey: CryptoJS.AES.encrypt(wallet.privateKey, keyData.pin).toString(),
                    publicKey: wallet.publicKey,
                    address: wallet.getAddress(),
                    subAddress: classicAddress,
                    changeAddress: '',
                    privIdx: 0,
                    changePrivIdx: 0,
                    accountNumber: 0,
                    type: 1,
                    platform: 'Ripple',
                    iconName: 'Ripple',
                    contractAddress: '',
                    tokenDecimals: 6,
                    amount: 0,
                    order: 3,
                    display: keyData.display,
                    initialized: false
                };
                if (keyData.order != 0) {
                    data.order = keyData.order;
                }
                return store.dispatch('idbAdd', {stateName: null, storeName: currencyAccountStoreName, data: data}, { root: true })
            })
            .then(function() {
                resolve(true);
            })
            .catch(function(e:any){
                console.error(e)
                reject('Ripple generate error');
            });
        });
    },

    addRippleAccount(store: any, payload: {pin: string, currencyData: currencyData}) {
        return new Promise(async (resolve) => {
            const mnemonic = await store.dispatch('getMnemonic', payload.pin);
            bip39.mnemonicToSeed(mnemonic) // ニーモニックから生成
            .then(function(seed: any) {
                console.log('seed', seed);
                let currencyData: currencyData = payload.currencyData;

                const test = (constant.blockchainEnv !== 'main');
                const wallet = Wallet.generateHDWalletFromSeed(seed, "m/44'/144'/"+ currencyData.accountNumber +"'/0/0", test);
                console.log(wallet.getAddress())
                console.log(wallet.privateKey);
                const classicAddress = rippleKP.deriveAddress(wallet.publicKey);

                currencyData.privateKey = CryptoJS.AES.encrypt(wallet.privateKey, payload.pin).toString();
                currencyData.publicKey = wallet.publicKey;
                currencyData.address = wallet.getAddress();
                currencyData.subAddress = classicAddress;

                store.dispatch('idbAdd', {stateName: null, storeName: currencyAccountStoreName, data: currencyData}, { root: true });
                resolve(true);
            });
        })
    },

    generateDummyAccount(store: any, keyData: generateKey) {
        return new Promise(async (resolve) => {
            const data: currencyData = {
                name: 'dummy' + keyData.order,
                symbol: 'DUM' + keyData.order,
                privateKey: CryptoJS.AES.encrypt('privateKey', keyData.pin).toString(),
                publicKey: '',
                address: 'address',
                subAddress: '',
                changeAddress: '',
                privIdx: 0,
                changePrivIdx: 0,
                accountNumber: 0,
                type: 1,
                platform: 'dummy',
                iconName: '',
                contractAddress: '',
                tokenDecimals: 0,
                amount: 0,
                order: 4,
                display: keyData.display,
                initialized: false
            };
            if (keyData.order != 0) {
                data.order = keyData.order;
            }

            await store.dispatch('idbAdd', {stateName: null, storeName: currencyAccountStoreName, data: data}, { root: true });
            resolve(true);
        });
    },

    getAllCurrencyAccounts(store: any) {
        return new Promise((resolve, reject) => {
            store.dispatch('idbSelectAll', {stateName: null, storeName: currencyAccountStoreName}, { root: true })
            .then(function(currencyList: currencyData[]) {
                resolve(currencyList);
            })
            .catch(function(){
                reject(null);
            });
        });
    },

    async getDisplayedCurrencyAccounts(store: any) {
        const currencyDataList = await store.dispatch('getAllCurrencyAccounts');
        console.log('currencyDataList', currencyDataList);

        // order順にソート
        const sortedList = currencyDataList.sort((a: any, b: any) => {
            return (a.order < b.order) ? -1 : (a.order > b.order) ? 1 : 0;
        });
        console.log('sortedList', sortedList);

        // 非表示のものをフィルター
        return sortedList.filter((item: any) => item.display);
    },

    getCurrencyAccount(store: any, name: string) {
        return new Promise((resolve, reject) => {
            store.dispatch('idbSelect', {stateName: null, storeName: currencyAccountStoreName, keyValue: name}, { root: true })
            .then(function(currencyData: currencyData) {
                resolve(currencyData);
            })
            .catch(function(){
                reject(null);
            });
        });
    },

    updateCurrencyAccount(store: any, data: any) {
        return new Promise((resolve, reject) => {
            store.dispatch('idbPut', {stateName: null, storeName: currencyAccountStoreName, data: data}, { root: true })
            .then(function() {
                resolve(true);
            })
            .catch(function(){
                reject();
            });
        });
    },

    /**
     *
     * @param store
     * @param data{
     *      account: any, // 必須propertyはnameとpropertyで指定したもの、,
     *      property: any // propertyは配列で複数更新可能
     * }
     */
    updateCurrencyAccountProperty(store: any, data: { account: any, property: any }) {
        return new Promise(async (resolve, reject) => {

            const latestData = await store.dispatch('idbSelect', {stateName: null, storeName: currencyAccountStoreName, keyValue: data.account.name}, { root: true })
            if (typeof data.property === 'string') {
                latestData[data.property] = data.account[data.property];
            } else if (typeof data.property === 'object') {
                for(let idx in data.property) {
                    const p = data.property[idx];
                    latestData[p] = data.account[p];
                }
            }
            store.dispatch('idbPut', {stateName: null, storeName: currencyAccountStoreName, data: latestData}, { root: true })
            .then(function() {
                resolve(true);
            })
            .catch(function(){
                reject();
            });
        });
    },

    updateCurrencyAccountAll(store: any, dataList: any[]) {
        return new Promise(async(resolve, reject) => {
            for (let i = 0; i < dataList.length; i++) {
                const data = dataList[i];
                await store.dispatch('idbPut', {stateName: null, storeName: currencyAccountStoreName, data: data}, { root: true });
            }
            resolve(true);
        });
    },

    generateNewCurrencyAccount(store: any, data: {pin: string, mnemonic: string, token: currencyData}) {
        return new Promise(async (resolve, reject) => {
            const keyData: generateKey = {
                mnemonic: data.mnemonic,
                pin: data.pin,
                order: data.token.order,
                display: false,
                restored: true
            }
            let result = true;
            switch (data.token.name) {
                case 'Bitcoin':
                    await store.dispatch('generateBitcoinAccount', keyData);
                    break;
                case 'Ether':
                    await store.dispatch('generateEthereumAccount', keyData);
                    break;
                case 'Ripple':
                    await store.dispatch('generateRippleAccount', keyData);
                    break;
                default:
                    // await store.dispatch('generateDummyAccount', keyData);
                    result = false;
                    break;
            }
            if (result) {
                resolve(true);
            } else {
                reject();
            }
        });
    },

    enterPreImport(store: any, payload: {data: currencyData, importProcess: number}) {
        return new Promise((resolve) => {
            store.commit('enterPreImport', payload);
            resolve(true);
        });
    },

    importNewCurrencyAccount(store: any, payload: {pin: string, currencyData: currencyData}) {
        return new Promise((resolve, reject) => {
            let importData = payload.currencyData;
            console.log('import', importData);
            importData.privateKey = CryptoJS.AES.encrypt(importData.privateKey, payload.pin).toString()
            store.dispatch('idbAdd', {stateName: null, storeName: currencyAccountStoreName, data: importData}, { root: true })
            .then(function() {
                resolve(true);
            });
        });
    },

    decryptWithPin(store: any, data: {pin: string, encrypted: string}) {
        return new Promise((resolve) => {
            const decrypted = CryptoJS.AES.decrypt(data.encrypted, data.pin).toString(CryptoJS.enc.Utf8);
            resolve(decrypted);
        });
    },

    accountExists(store: any) {
        return new Promise((resolve, reject) => {
            store.dispatch('idbSelect', {stateName: null, storeName: settingStoreName, keyValue: 'generateMnemonic'}, { root: true })
            .then(function(data: any) {
                console.log('accountExists data', data);
                // let res =false;
                // if (data !== undefined && data.optValue !== undefined && data.optValue !== null && data.optValue !== '') {
                //     res = true;
                // }
                let res = true;
                if (data === undefined || data === null) {
                    res = false;
                } else if (!data.hasOwnProperty('optValue')) {
                    res = false;
                } else if (data.optValue === undefined || data.optValue === null || data.optValue === ''){
                    res = false;
                }
                /**
                 * 対応通貨追加時はここにアカウント作成処理を追加
                 * displayはfalseで
                 */

                resolve(res);
            })
            .catch(function(e: any){
                console.log('accountExists data reject', e);
                resolve(false);
            });
        });
    },

    getMnemonic(store: any, pin: string) {
        return new Promise((resolve, reject) => {
            store.dispatch('idbSelect', {stateName: null, storeName: settingStoreName, keyValue: 'generateMnemonic'}, { root: true })
            .then(function(settings: any) {
                console.log('settings', settings);
                const encrypted = {
                    pin: pin,
                    encrypted: settings.optValue
                }
                return store.dispatch('decryptWithPin', encrypted);
            })
            .then(function(decrypted: string) {
                console.log('decrypted', decrypted);
                const mnemonicArray = decrypted.replace(/　/g, ' ').split(' ');
                if (mnemonicArray.length == 12) {
                    // 自身のニーモニックを変数にセット
                    resolve(decrypted);
                } else {
                    reject('decryptError');
                }
            })
            .catch(function() {
                reject('no mnemonic');
            });
        });
    },

    enterMnemonic(store: any, mnemonic: string) {
        return new Promise((resolve) => {
            store.commit('enterMnemonic', mnemonic);
            resolve(true);
        });
    },

    // createPublicAccount(store: any, publicKey: string) {
    //     return new Promise((resolve, reject) => {
    //         // 公開鍵を取得
    //         store.dispatch('idbSelect', {stateName: null, storeName: settingStoreName, keyValue: 'pub'}, { root: true })
    //         .then(function(pubData: any) {
    //             const params = new URLSearchParams();
    //             params.append('public_key', pubData.optValue);
    //             // 公開鍵を送信
    //             return axios.post(constant.apiHost + '/api/public-account/create', params)
    //         })
    //         .then((response: any) => {
    //             if (response.data.status == 'success') {
    //                 resolve(true);
    //             } else {
    //                 resolve(false);
    //             }
    //         })
    //         .catch(function() {
    //             reject('unknown error2');
    //         });
    //     });
    // },
    checkUnspentAddr(store: any, data: {address: string, platform: string}) {
        return new Promise((resolve, reject) => {

            const urlTx = `https://blockstream.info/${blockStreamApiPath}api/address/${data.address}/txs`;
            axios.get(urlTx)
            .then((response: any) => {
                console.log('unspentcheckResponse', response.data);
                if (response.data.length > 0) {
                    resolve(false); // used
                } else {
                    resolve(true); // unused
                }
            })
            .catch(function(e: any) {
                console.error(e);
                reject(`cannot check unspent ${data.platform} addr`);
            });
        });
    },

    createMultiSigAddress(store: any, data:{
        masterPriv: any,
        change: boolean,
        accountNumber: number,
        privIdx: number,
        platform: string
    }) {
        return new Promise((resolve, reject) => {
            try {
                console.log('data',data);

                let privIdx = data.privIdx;
                const change = (data.change)?'1':'0';
                let privateKeys = [];
                let publicKeys = [];

                // 署名はこの秘密鍵と、親秘密鍵から"m/44'/0'/accountNumber'/0/privIdx"のpathで割り出した秘密鍵によって2of2で行なわれる
                // 0or偶数＆奇数番号のgapNumberによってひとつのアドレスが構成される
                for (let i=0; i < 2; i++) {
                    // 親秘密鍵 -> 子秘密鍵 "m/44'/0'/a'/c/i"
                    // ここのaはアカウント追加によってのみ増える
                    // iはprivIdx*2+0,privIdx*2+1
                    const path = "m/44'/0'/" + String(data.accountNumber) + "'/" + change + "/" + String(privIdx*2+i);
                    console.log('path:', path);
                    const xpriv = data.masterPriv.deriveChild(path);
                    console.log("xpriv: " + xpriv.toString());
                    console.log("privateKeyOrg: " + xpriv.privateKey);

                    // publicKeys[i] = new bitcore.PublicKey(privateKeys[i], constant.blockchainEnvName.Bitcoin).toString();
                    publicKeys[i] = new bitcore.PrivateKey(xpriv.privateKey).publicKey.toString();

                    // privateKeys[i] = new bitcore.PrivateKey(xpriv.privateKey.toString(), constant.blockchainEnvName.Bitcoin);
                    privateKeys[i] = xpriv.privateKey;
                    console.log("privateKey: " + privateKeys[i]);
                    console.log("publicKey: " + publicKeys[i]);
                }
                const address = new bitcore.Address(publicKeys, 2, constant.blockchainEnvName.Bitcoin);
                console.log("address: " + address.toString());

                resolve({
                    address: address.toString(),
                    privateKeys: privateKeys, //wif
                    publicKeys: publicKeys
                });
            } catch (e) {
                console.error(e);
                reject({
                    address: '',
                    privateKeys: [],
                    publicKeys: []
                });
            }
        })
    },

}

const mutations = {
    enterMnemonic(state: any, mnemonic: string) {
        state.enteredMnemonic = mnemonic;
    },

    enterPreImport(state: any, data: any) {
        state.preImport = data;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
